import "./download.scss";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

import React, {useEffect} from 'react';
import { isAndroid, isIOS } from "react-device-detect";

import appStoreImage from '../../assets/img/download/app-store-button.svg'
import playStoreImage from '../../assets/img/download/play-store-button.svg'
import {Helmet} from "react-helmet";

const Download = () => {
  useEffect(() => {
    if (isAndroid) {
      
      window.location.href = "https://play.google.com/store/apps/details?id=io.xerinola.xerinola";
    }
    else if(isIOS) {
      window.location.href = "https://apps.apple.com/es/app/xerinola/id1617898157";
    }
  }, []);
  
  return (
    <>
    <main>
      <Helmet>
        <meta property="title" content="Xerinola - App" />
        <meta property="og:title" content="Xerinola - App" />
        <meta property="og:url" content="https://xerinola.io/app" />
      </Helmet>
      <Header section="App"/>
      <div className="buttons-container">
        <div className="content">
          <h3>Descarrega l'app!</h3>
          <div className="buttons-box">
            <div className="button">
              <a href="https://apps.apple.com/es/app/xerinola/id1617898157"><img src={appStoreImage} alt=""/></a>
            </div>
            <div className="button">
              <a href="https://play.google.com/store/apps/details?id=io.xerinola.xerinola"><img src={playStoreImage} alt=""/></a>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Footer />
    </>
  );
}

export default Download
